import React from 'react';
import ReactDOM from 'react-dom';
import Body from './Pages/Body';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <Body />
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
